export interface ISetBoundary {
  number?: number | string;
  min?: number;
  max?: number;
  loop?: boolean;
}

/**
 * Añade límites a un número, impidiendo que sea
 * inferior o superior a los límites establecidos.
 *
 * Si se pasa loop en true, al llegar al valor maximo o minimo regresara al
 * minimo o maximo respectivamente.
 */
export function addBoundary(
  num: number,
  min: number,
  max?: number,
  loop?: boolean,
): number;
export function addBoundary(definition: ISetBoundary): number;
export function addBoundary(
  definition: ISetBoundary | number,
  min?: number,
  max?: number,
  loop?: boolean,
) {
  const actualNumber =
    typeof definition === 'number' ? definition : definition.number;
  const actualMin = typeof definition === 'number' ? min : definition.min;
  const actualMax = typeof definition === 'number' ? max : definition.max;
  const isActualLoop = typeof definition === 'number' ? loop : definition.loop;

  let newNumber = Number(actualNumber ?? 0);
  if (actualMin !== undefined && newNumber < actualMin) {
    if (actualMax !== undefined && isActualLoop) {
      newNumber = actualMax;
    } else {
      newNumber = actualMin;
    }
  }
  if (actualMax !== undefined && newNumber > actualMax) {
    if (actualMin !== undefined && isActualLoop) {
      newNumber = actualMin;
    } else {
      newNumber = actualMax;
    }
  }
  return newNumber;
}

const sizeUnits = ['b', 'kb', 'mb', 'gb', 'tb'];
/**
 * Esta función acepta un número y devuelve la representaciíon
 * en string de su tamaño en disco. Ej: 1024 => 1kb
 */
export function parseAsSize(num: number): string {
  let index = 0;
  let finalSize = num;

  if (finalSize === Infinity) return '1000GB';

  while (finalSize > 1024) {
    finalSize /= 1024;
    index++;
  }
  return `${Math.round(finalSize * 10) / 10}${sizeUnits[index]}`;
}

/**
 * Toma cualquier valor y devuelve siempre un número. En caso de que el valor
 * casteado con la función Number(value) de NaN, devuelve defaultReturn, que por
 * defecto es 0
 */
export function noNaN(number: unknown, defaultReturn = 0) {
  const returnNumber = Number(number);
  if (number === null || Number.isNaN(returnNumber)) return defaultReturn;
  return returnNumber;
}
